
import { Component, Prop, Vue } from "vue-property-decorator"
import { CircularLoader, PullRefresh, Require } from "@coredination/components"
import EntityEventSubscription from "@/graphql/subscription/entityevent.graphql"

import CustomerDetailQuery from "@/graphql/customer/customerdetail.graphql"
import * as cdn from "@coredination/components"
import { User } from "@coredination/common"

@Component({
    components: {
        CircularLoader,
        PullRefresh,
        Require,
        LabelField: () => import("@/components/fields/LabelField.vue"),
        GroupField: () => import("@/components/fields/GroupField.vue"),
        FreeTextField: () => import("@/components/fields/FreeTextField.vue"),
        CustomFieldsField: () => import("@/components/fields/CustomFieldsField.vue"),
        LocationField: () => import("@/components/fields/LocationField.vue"),
        SingleContactField: () => import("@/components/fields/SingleContactField.vue"),
        AddressField: () => import("@/components/fields/AddressField.vue"),
    },
    apollo: {
        me: cdn.graphql.me,
        customer: {
            query: CustomerDetailQuery,
            skip() {
                return !this.uuid
            },
            variables() {
                return { uuid: this.uuid }
            },
        },
        $subscribe: {
            entityEvent: {
                query: EntityEventSubscription,
                result(result: any) {
                    const event = result.data.entityEvent
                    if (
                        event.type == "entityUpdated" &&
                        event.data &&
                        event.data.entityClass == "Customer" &&
                        event.data.uuid == this.model.uuid
                    ) {
                        console.log("customer was updated", event.data)
                        if (this.customer.version >= event.data.version) {
                            console.log("not refreshing - same version")
                        } else {
                            console.log("refreshing")
                            this.refresh()
                        }
                    }
                },
            },
        },
    },
})
export default class CustomerView extends Vue {
    @Prop()
    uuid?: string

    customer: any = {}
    refreshing = false

    me?: User

    get fabOptions() {
        return [
            {
                title: this.$t("createNewJob"),
                to: `/job/new?customer=${this.model.uuid}`,
                if: () => this.me && this.me.hasFeature("jobs"),
            },
        ]
    }
    get loading() {
        return this.refreshing || (this.$apollo.loading && !this.customer.name)
    }

    get model() {
        return this.customer
    }
    set model(updated: any) {
        this.customer = updated
    }

    get termsOfPayment(){
        if (this.customer?.termsOfPaymentText) return this.customer.termsOfPaymentText
        if (this.customer?.termsOfPaymentDays) return this.customer.termsOfPaymentDays + " " + this.$t("_days")
        return null
    }

    hasInvoicing() {
        return this.customer && 
            ( this.customer.invoiceContact ||
            this.customer.termsOfPayment ||
            this.customer.invoiceAddress ||
            this.customer.currency ||
            this.customer.vatNumber
        )
    }

    hasMultipleActiveGroups() {
        return this.me && this.me.groupMemberships && this.me.groupMemberships.filter((m: any) => m.active).length > 1
    }

    async refresh() {
        this.refreshing = true
        await this.$apollo.queries.customer.refetch()
        this.refreshing = false
    }

    iosWrapperClient() {
        return Vue.prototype.$iosWrapperClient
    }
}
